<template>
	<div class="rating">
		<div
			class="rating__incr"
			v-for="n in 5"
			:key="n"
			:class="{ filled: n <= normalizeScore }"
		></div>
	</div>
</template>

<script>
export default {
	name: 'Rating',
	props: {
		rating: {
			type: Number,
			required: false,
		},
		scale: {
			type: Object,
			required: false,
		},
	},
	computed: {
		normalizeScore: function() {
			if (this.rating > this.scale.five) {
				return 5;
			}
			if (this.rating > this.scale.four) {
				return 4;
			}
			if (this.rating > this.scale.three) {
				return 3;
			}
			if (this.rating > this.scale.two) {
				return 2;
			}
			return 1;
		},
	},
};
</script>

<style lang="less" scoped>
.rating {
	width: 100%;
	max-width: 125px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border-radius: 12px;
	height: 9px;
	.rating__incr {
		background-color: #edf2f5;
		height: 100%;
		width: 20%;
		&.filled {
			&:nth-child(1) {
				background-color: #fbdc69;
				background: linear-gradient(to right, #fbdc69 0%, #d5d452 100%);
			}
			&:nth-child(2) {
				background-color: #d5d452;
				background: linear-gradient(to right, #d5d452 0%, #abcb38 100%);
			}
			&:nth-child(3) {
				background-color: #fbdc69;
				background: linear-gradient(to right, #abcb38 0%, #80ba4e 100%);
			}
			&:nth-child(4) {
				background-color: #fbdc69;
				background: linear-gradient(to right, #80ba4e 0%, #559f9f 100%);
			}
			&:nth-child(5) {
				background-color: #fbdc69;
				background: linear-gradient(to right, #559f9f 0%, #2985ed 100%);
			}
		}
		&:not(:last-child) {
			margin-right: 1px;
		}
	}
}
</style>
